<template>
  <div class="py-4 container-fluid">
    <GridRow class="gap-4">
      <GridCol :md="12">
        <meta-section>
          <div class="text-right">
            <div class="d-flex flex-row gap-2">
              <ArgonButton outline :to="{ name: 'Laporan Kpi Pegawai' }">Kembali</ArgonButton>
              <!-- <ArgonButton outline @click="generateReport()">Export PDF</ArgonButton> -->
              <!-- <button @click="generateReport()" class="btn btn-outline-secondary mb-0">Export PDF</button> -->
              <button @click="getExportPdf()" class="btn btn-outline-secondary mb-0">Export PDF</button>
            </div>
          </div>
        </meta-section>
      </GridCol>
      
      <GridCol :md="12" style="display: none;">
        <card-component :withmin="false">
          <vue3-html2pdf
            :show-layout="false"
            :float-layout="false"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="110"
            :filename="'laporan_kpi_pegawai_'+ employee?.name?.replaceAll(' ', '_')?.toLowerCase() +'_'+ moment()"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"

            ref="html2Pdf"
          >
            <!-- :paginate-elements-by-height="1400" -->
            <!-- @progress="onProgress($event)"
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)" -->
            <template v-slot:pdf-content>
              <!-- PDF Content Here -->
              <div class="p-4" style="margin-bottom: 30rem;">
                <!-- <img src="@/assets/img/watermark.png" alt="" style="position: absolute; top: 450px; z-index: 99; transform: rotate(-45deg); opacity: 1;">
                <img src="@/assets/img/watermark.png" alt="" style="position: absolute; top: 1550px; z-index: 99; transform: rotate(-45deg); opacity: 1;"> -->
                <img src="@/assets/img/watermark-2.png" alt="" style="position: absolute; top: 0px; z-index: 99; width: 95%; opacity: .5;">
                <img src="@/assets/img/watermark-2.png" alt="" style="position: absolute; top: 1100px; z-index: 99; width: 95%; opacity: .5;">
                <img src="@/assets/img/watermark-2.png" alt="" style="position: absolute; top: 2150px; z-index: 99; width: 95%; opacity: .5;">
                
                <div class="text-center">
                  <h1 style="font-size: 20px;">Kertas Penilaian Kinerja</h1>
                  <!-- <p>PEMIMPIN CABANG</p> -->
                  <hr>
                </div>
                <!-- profiling -->
                <div class="row">
                  <div class="col">
                    <table class="report-table report-table--information">
                      <tr>
                        <th scope="row" width="100">Nama</th>
                        <td width="10">:</td>
                        <td>{{ employee?.name ?? "-" }}</td>
                      </tr>
                      <tr>
                        <th scope="row">NIP</th>
                        <td>:</td>
                        <td>{{ employee?.nip || '-' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Jabatan</th>
                        <td>:</td>
                        <td>{{ employee?.jabatan?.name || '-' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Unit Kerja</th>
                        <td>:</td>
                        <td>{{ employee?.unitkerja?.name || '-' }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Periode Penilaian</th>
                        <td>:</td>
                        <td>{{ periode_active?.name || '-' }}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col">
                    <table class="report-table report-table--information">
                      <tr>
                        <th scope="row" width="100">Penilai</th>
                        <td width="10">:</td>
                        <td>{{ employee?.leader?.name ?? "-" }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Atasan Penilai</th>
                        <td>:</td>
                        <td>{{ employee?.unitkerja?.leader?.name ?? "-" }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Diunduh Pada</th>
                        <td>:</td>
                        <td>{{ moment().locale('id').format('DD MMMM YYYY') }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Diunduh Oleh</th>
                        <td>:</td>
                        <td>{{ employee_login?.name || '-' }}</td>
                      </tr>
                    </table>
                  </div>

                </div>
                <!-- penilaian kinerja -->
                <div class="block-area-report">
                  <h2 class="block-area-report--heading">Penilaian Kinerja</h2>
                  <table class="report-table report-table--main">
                      <thead>
                          <tr>
                            <th scope="col" style="width: 24px;" class="text-center" rowspan="3">No.</th>
                            <th scope="col" colspan="2">KPI</th>
                            <th scope="col">Target</th>
                            <th scope="col">Realisasi</th>
                            <th scope="col">Pencapaian</th>
                            <th scope="col">Nilai</th>
                            <th scope="col">Bobot</th>
                            <th scope="col">Jumlah</th>
                          </tr>
                      </thead>

                      <tbody>
                        <template v-if="list_penilaian_kinerja?.list_kpi?.length > 0">
                          <template v-for="(item, index) in list_penilaian_kinerja.list_kpi" :key="item">
                            <tr>
                              <td style="width: 24px;" class="text-center">{{ index + 1 }}</td>
                              <td colspan="7">{{ item?.kpi || '-' }}</td>
                              <td class="text-center"><strong>{{ item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : '-' }}</strong></td>
                            </tr>
                            <tr v-for="(sub_item, i) in item.sub_kpi" :key="sub_item">
                              <td></td>
                              <td style="width: 24px;" class="text-center">{{ `${index + 1}.${i + 1}` }}</td>
                              <td>{{ sub_item?.nama_aspek_kpi || '-' }}</td>
                              <td class="text-end">
                                <!-- {{
                                  new Intl.NumberFormat('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                  }).format(sub_item?.target || '0')
                                }} -->
                                <span v-if="sub_item?.satuan?.toLowerCase() === 'rupiah'">
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub_item?.target || '0')
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(sub_item?.target || '0')
                                  }} 
                                  <span class="text-capitalize">{{ (sub_item?.satuan?.toLowerCase() === 'persen' ? '%' : sub_item?.satuan) || '-' }}</span>
                                </span>
                              </td>
                              <td class="text-end">
                                <!-- {{
                                  new Intl.NumberFormat('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                  }).format(sub_item?.realisasi || '0')
                                }} -->
                                 <span v-if="sub_item?.satuan?.toLowerCase() === 'rupiah'">
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                      }).format(sub_item?.realisasi || '0')
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        minimumFractionDigits: 0,
                                      }).format(sub_item?.realisasi || '0')
                                    }} 
                                    <span class="text-capitalize">{{ (sub_item?.satuan?.toLowerCase() === 'persen' ? '%' : sub_item?.satuan) || '-' }}</span>
                                  </span>
                              </td>
                              <td class="text-center">{{ sub_item?.pencapaian ? sub_item.pencapaian +'%' : '-' }}</td>
                              <td class="text-center">
                                {{
                                  new Intl.NumberFormat('id-ID', {
                                    minimumFractionDigits: 0,
                                  }).format(sub_item?.nilai || '0')
                                }}
                              </td>
                              <td class="text-center">{{ sub_item?.bobot || sub_item?.bobot === 0 ? sub_item?.bobot : '-' }}</td>
                              <td class="text-center">{{ sub_item?.jumlah || sub_item?.jumlah === 0 ? sub_item?.jumlah : '-' }}</td>
                            </tr>
                          </template>
                        </template>
                        <tr v-else>
                          <td colspan="9" class="text-center">Data tidak ditemukan.</td>
                        </tr>
                      </tbody>
                  </table>
                  <br>
                  <table class="report-table report-table--main report-table--result">
                      <thead>
                        <tr>
                          <th scope="col" rowspan="2" style="width: 70%">Hasil Penilaian Kinerja</th>
                          <th scope="col" class="text-center">Bobot Total</th>
                          <th scope="col" class="text-center">Jumlah</th>
                          <th scope="col" class="text-center">Nilai Kinerja</th>
                        </tr>
                      </thead>
                      <tbody>
                          <tr>
                            <td class="text-center">{{ list_penilaian_kinerja?.bobot_total || list_penilaian_kinerja?.bobot_total === 0 ? list_penilaian_kinerja.bobot_total : '-' }}</td>
                            <td class="text-center">{{ list_penilaian_kinerja?.sub_jumlah_kinerja || list_penilaian_kinerja?.sub_jumlah_kinerja === 0 ? list_penilaian_kinerja.sub_jumlah_kinerja : '-' }}</td>
                            <td class="text-center"><strong>{{ list_penilaian_kinerja?.average_kinerja || list_penilaian_kinerja?.average_kinerja === 0 ? list_penilaian_kinerja.average_kinerja : '-' }}</strong></td>
                          </tr>
                      </tbody>
                  </table>
                </div>
                <!-- end penilaian kinerja -->
                <!-- penugasan khusus -->
                <div class="block-area-report">
                  <h2 class="block-area-report--heading">Penugasan Khusus</h2>
                  <table class="report-table report-table--main">
                      <thead>
                          <tr>
                            <th scope="col" style="width: 24px;" class="text-center">No.</th>
                            <th scope="col">Jenis Penugasan</th>
                            <th scope="col">Nilai</th>
                          </tr>
                      </thead>
                      <tbody>
                        <template v-if="list_penugasan_khusus?.list_penugasan?.length > 0">
                          <template v-for="(item, index) in list_penugasan_khusus?.list_penugasan" :key="item">
                            <tr>
                              <td class="text-center">{{ index +1  }}</td>
                              <td>{{ item?.name || '-' }}</td>
                              <td v-if="index === 0" class="text-center" :rowspan="list_penugasan_khusus.list_penugasan.length">
                                <strong>{{ list_penugasan_khusus?.nilai || list_penugasan_khusus?.nilai === 0 ? list_penugasan_khusus.nilai : '-'  }}</strong>
                              </td>
                            </tr>
                          </template>
                        </template>
                        <tr v-else>
                          <td colspan="3" class="text-center">Data tidak ditemukan.</td>
                        </tr>
                      </tbody>
                  </table>
                </div>
                <!-- end penugasan khusus -->
                <!-- pengurangan -->
                <div class="block-area-report">
                  <h2 class="block-area-report--heading">Faktor Pengurangan KPI</h2>
                  <table class="report-table report-table--main">
                      <thead>
                          <tr>
                            <th scope="col" style="width: 24px;" class="text-center">No.</th>
                            <th scope="col">Tingkat Masalah</th>
                            <th scope="col" style="width: 80px;">Jumlah</th>
                          </tr>
                      </thead>
                      <tbody>
                        <template v-if="list_pengurangan?.detail?.length > 0">
                          <tr v-for="(item, index) in list_pengurangan?.detail" :key="item">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td>{{ item?.tingkat_permasalahan || '-' }}</td>
                            <td class="text-center">{{ item?.jumlah_permasalahan || item?.jumlah_permasalahan === 0 ? item.jumlah_permasalahan : '-' }}</td>
                          </tr>
                          <tr>
                            <td colspan="2" class="text-end"><strong>Total</strong></td>
                            <td class="text-center"><strong>{{ list_pengurangan?.nilai_akhir_pengurangan || list_pengurangan?.nilai_akhir_pengurangan === 0 ? list_pengurangan.nilai_akhir_pengurangan : '-' }}</strong></td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="3" class="text-center">Data tidak ditemukan.</td>
                        </tr>
                      </tbody>
                  </table>
                </div>
                <!-- end pengurangan -->
                <!-- Kompetensi -->
                <div class="block-area-report">
                  <h2 class="block-area-report--heading">Kompetensi</h2>
                  <table class="report-table report-table--main">
                      <thead>
                          <tr>
                            <th scope="col" style="width: 24px;" class="text-center">No.</th>
                            <th scope="col" colspan="2">Kompetensi</th>
                            <th scope="col">Level</th>
                            <th scope="col">Deskripsi</th>
                            <th scope="col" style="width: 80px;">Nilai</th>
                          </tr>
                      </thead>
                      <tbody>
                        <template v-if="list_kompetensi_inti?.length > 0">
                          <tr v-for="(item, index) in list_kompetensi_inti" :key="item">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td v-if="index === 0" :rowspan="list_kompetensi_inti.length" style="white-space: nowrap; vertical-align: top">Kompetensi Inti</td>
                            <td style="white-space: nowrap">{{ item?.kompetensi || '-' }}</td>
                            <td class="text-center">{{ item?.nilai || item?.nilai  === 0 ? item?.nilai : '-' }}</td>
                            <td>{{ item.list_kompetensi?.['level'+ item?.nilai] || '-' }}</td>
                            <td class="text-center">{{ item?.nilai || item?.nilai  === 0 ? item?.nilai : '-' }}</td>
                          </tr>
                        </template>

                        <template v-if="list_kompetensi_manajerial?.length > 0">
                          <tr v-for="(item, index) in list_kompetensi_manajerial" :key="item">
                            <td class="text-center">{{ index + 1 }}</td>
                            <td v-if="index === 0" :rowspan="list_kompetensi_manajerial.length" style="white-space: nowrap; vertical-align: top">Kompetensi Inti</td>
                            <td style="white-space: nowrap">{{ item?.kompetensi || '-' }}</td>
                            <td class="text-center">{{ item?.nilai || item?.nilai  === 0 ? item?.nilai : '-' }}</td>
                            <td>{{ item.list_kompetensi?.['level'+ item?.nilai] || '-' }}</td>
                            <td class="text-center">{{ item?.nilai || item?.nilai  === 0 ? item?.nilai : '-' }}</td>
                          </tr>
                        </template>

                        <tr v-if="list_kompetensi_inti.length === 0 && list_kompetensi_manajerial.length === 0">
                        <td colspan="5" class="text-center">Data tidak ditemukan.</td>
                      </tr>
                      </tbody>
                  </table>
                </div>
                <!-- end Kompetensi -->
                <!-- Nilai akhir -->
                <div class="block-area-report">
                  <h2 class="block-area-report--heading">Nilai Akhir</h2>
                  <table class="report-table report-table--main">
                      <thead>
                          <tr>
                            <th scope="col" style="width: 24px;" class="text-center">No.</th>
                            <th scope="col">Kategori</th>
                            <th scope="col">Nilai</th>
                            <th scope="col">Bobot</th>
                            <th scope="col">Nilai Akhir</th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-center">1</td>
                          <td>Rata-rata Nilai Kinerja	</td>
                          <td class="text-center">{{ data_penilaian_akhir?.nilai_kinerja?.average_kinerja || data_penilaian_akhir?.nilai_kinerja?.average_kinerja === 0 ? data_penilaian_akhir.nilai_kinerja.average_kinerja : '-' }}</td>
                          <td class="text-center">{{ data_penilaian_akhir?.nilai_kinerja?.bobot_kinerja || data_penilaian_akhir?.nilai_kinerja?.bobot_kinerja === 0 ? data_penilaian_akhir.nilai_kinerja.bobot_kinerja +'%' : '-' }}</td>
                          <td class="text-center">{{ data_penilaian_akhir?.nilai_kinerja?.nilai_akhir_kinerja || data_penilaian_akhir?.nilai_kinerja?.nilai_akhir_kinerja === 0 ? data_penilaian_akhir.nilai_kinerja.nilai_akhir_kinerja : '-' }}</td>
                        </tr>
                        <tr>
                          <td class="text-center">2</td>
                          <td>Rata-rata Perilaku Kompetensi</td>
                          <td class="text-center">{{ data_penilaian_akhir?.kompetensi?.average_kompetensi || data_penilaian_akhir?.kompetensi?.average_kompetensi === 0 ? data_penilaian_akhir.kompetensi.average_kompetensi : '-' }}</td>
                          <td class="text-center">{{ data_penilaian_akhir?.kompetensi?.bobot_kompetensi || data_penilaian_akhir?.kompetensi?.bobot_kompetensi === 0 ? data_penilaian_akhir.kompetensi.bobot_kompetensi +'%' : '-' }}</td>
                          <td class="text-center">{{ data_penilaian_akhir?.kompetensi?.nilai_akhir_kompetensi || data_penilaian_akhir?.kompetensi?.nilai_akhir_kompetensi === 0 ? data_penilaian_akhir.kompetensi.nilai_akhir_kompetensi : '-' }}</td>
                        </tr>
                        <tr>
                          <td class="text-center">3</td>
                          <td colspan="3">Penugasan Khusus, Rangkap Jabatan, Inovasi & Kreatifitas</td>
                          <td class="text-center">{{ data_penilaian_akhir?.penugasan_khusus || data_penilaian_akhir?.penugasan_khusus === 0 ? data_penilaian_akhir.penugasan_khusus : '-' }}</td>
                        </tr>
                        <tr>
                          <td class="text-center">4</td>
                          <td colspan="3">Faktor Pengurang KPI</td>
                          <td class="text-center">{{ data_penilaian_akhir?.pengurang || data_penilaian_akhir?.pengurang === 0 ? data_penilaian_akhir.pengurang : '-' }}</td>
                        </tr>
                        <tr>
                          <td class="text-end" colspan="4"><strong>Nilai Akhir Penilaian</strong></td>
                          <td class="text-center"><strong>{{ data_penilaian_akhir?.nilai_akhir || data_penilaian_akhir?.nilai_akhir === 0 ? data_penilaian_akhir.nilai_akhir : '-' }}</strong></td>
                        </tr>
                        <tr>
                          <td class="text-end" colspan="4"><strong>Indeks</strong></td>
                          <td class="text-center"><strong>{{ data_penilaian_akhir?.indeks || '-' }}</strong></td>
                        </tr>
                      </tbody>
                  </table>
                </div>
                <!-- end Nilai akhir -->

                  <!-- <img class="img-fluid position-absolute h-100" style="object-fit: cover;" v-lazy="require('@/assets/img/logo-bank-sumselbabel-color.png')" alt=""> -->
                  <!-- <img class="h-100" style="" v-lazy="require('@/assets/img/logo-bank-sumselbabel-color.png')" alt=""> -->
                
                <p class="text-bold text-sm mt-5"><strong>Tanggal Persetujuan Kontrak Kerja : {{ moment().lang('id').format('DD MMMM YYYY') }}</strong></p>
                <!-- <div class="row"> -->
                <div class="d-flex justify-content-between" style="padding: 0 32px">
                  <div class="text-center text-sm">
                    <p>Atasan Langsung,</p>
                    <br /><br /><br />
                    <p class="border-bottom">{{ employee?.leader?.name ?? "-" }}</p>
                  </div>
                  <div class="text-center text-sm">
                    <p>Penerima Kontrak Kerja,</p>
                    <br /><br /><br />
                    <p class="border-bottom">{{ employee?.name || '-' }}</p>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <div class="text-center text w-auto">
                    <p>Atasan dari Atasan Langsung,</p>
                    <br /><br /><br />
                    <p class="border-bottom">{{ employee?.unitkerja?.leader?.name ?? "-" }}</p>
                  </div>
                </div>
              </div>
            </template>

          </vue3-html2pdf>
        </card-component>
      </GridCol>
      
      <GridCol :md="12">
        <card-component :withmin="false">
          <div class="d-flex flex-row gap-2">
            <div v-if="employee?.photo != ''"
              style="width: 8.1112vw;height: 8.1112vw;position: relative;margin: 0 auto;">
              <!-- <img :src="employee?.photo" class="img-fluid" style="width: 8.1112vw;height: 8.1112vw;"> -->
              <div class="bg-secondary rounded-2 p-0" style="width: 92px !important; height: 92px !important; "></div>
            </div>
            <div class="d-flex flex-column w-100">
              <div class="form-group">
                <span class="m-0">Nama</span>
                <div>
                  {{ employee?.name ?? "-" }}
                </div>
              </div>
              <div class="form-group">
                <span class="m-0">No.</span>
                <div>
                  {{ employee?.nip ?? "-" }}
                </div>
              </div>
            </div>

            <div class="d-flex flex-column w-100">
              <div class="form-group">
                <span class="m-0">Jabatan</span>
                <div>
                  {{ employee?.jabatan?.name ?? "-" }}
                </div>
              </div>
              <div class="form-group">
                <span class="m-0">Posisi</span>
                <div>
                  {{ employee?.position || '-' }}
                </div>
              </div>
            </div>

            <div class="d-flex flex-column w-100">
              <div class="form-group">
                <span class="m-0">Unit Kerja</span>
                <div>
                  {{ employee?.unitkerja?.name ?? "-" }}
                </div>
              </div>
              <div class="form-group">
                <span class="m-0">Periode KPI</span>
                <div>
                  {{ periode_active?.name || '-' }}
                </div>
              </div>
            </div>

            <div class="d-flex flex-column w-100">
              <div class="form-group">
                <span class="m-0">Direct Supervisor</span>
                <div>
                  {{ employee?.leader?.name ?? "-" }}
                </div>
              </div>
              <div class="form-group">
                <span class="m-0">Immediate Supervisor</span>
                <div>
                  {{ employee?.unitkerja?.leader?.name ?? "-" }}
                </div>
              </div>
            </div>
          </div>
        </card-component>
      </GridCol>

      <GridCol :md="12">
        <CardComponent :withmin="false" :p="0" class="card--tabs">
          <tabbed-pane
            :tabs="{ 'Penilaian Kinerja': true, 'Penugasan Khusus': false, 'Pengurangan': false, 'Kompetensi': false, 'Penilaian Akhir': false }">

            <div class="tab-pane fade show active p-4 pt-0" id="pills-penilaian-kinerja" role="tabpanel"
              aria-labelledby="pills-penilaian-kinerja-tab">
              <FieldsetComponent title="Periode Penilaian" :isFieldsetRow="true">

                <div class="mt-2" v-if="list_penilaian_kinerja?.list_kpi?.length > 0">
                  <div
                    v-for="(item, index) in list_penilaian_kinerja.list_kpi"
                    :key="item"
                    class="d-flex flex-column gap-2"
                  >
                    <div class="d-flex flex-row justify-content-between mt-3">
                      <div>{{ item?.kpi || '-' }}</div>
                      <div class="text-right">{{ item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : '-' }}</div>
                    </div>
                    
                    <list-view :thead="['Sub KPI', 'Pencapaian', 'Nilai', 'Bobot', 'Jumlah']">
                      <template v-slot:tbody>
                        <tr
                          v-for="sub_item in item.sub_kpi"
                          :key="sub_item"
                        >
                          <td>
                            {{ sub_item?.nama_aspek_kpi || '-' }}
                            <table>
                              <tr>
                                <th scope="row" style="color: #7D8286">Target</th>
                                <td style="color: #7D8286">:</td>
                                <td>
                                  <span v-if="sub_item?.satuan?.toLowerCase() === 'rupiah'">
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                      }).format(sub_item?.target || '0')
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        minimumFractionDigits: 0,
                                      }).format(sub_item?.target || '0')
                                    }} 
                                    <span class="text-capitalize">{{ (sub_item?.satuan?.toLowerCase() === 'persen' ? '%' : sub_item?.satuan) || '' }}</span>
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <th scope="row" style="color: #7D8286">Realisasi</th>
                                <td style="color: #7D8286">:</td>
                                <td>
                                  <span v-if="sub_item?.satuan?.toLowerCase() === 'rupiah'">
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                      }).format(sub_item?.realisasi || '0')
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        minimumFractionDigits: 0,
                                      }).format(sub_item?.realisasi || '0')
                                    }} 
                                    <span class="text-capitalize">{{ (sub_item?.satuan?.toLowerCase() === 'persen' ? '%' : sub_item?.satuan) || '' }}</span>
                                  </span>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td>{{ sub_item?.pencapaian ? sub_item.pencapaian +'%' : '-' }}</td>
                          <td>
                            {{
                              new Intl.NumberFormat('id-ID', {
                                minimumFractionDigits: 0,
                              }).format(sub_item?.nilai || '0')
                            }}
                          </td>
                          <td>{{ sub_item?.bobot || sub_item?.bobot === 0 ? sub_item?.bobot : '-' }}</td>
                          <td>{{ sub_item?.jumlah || sub_item?.jumlah === 0 ? sub_item?.jumlah : '-' }}</td>
                        </tr>
                      </template>
                    </list-view>
                    <hr v-if="(index + 1) !== list_penilaian_kinerja.list_kpi.length">
                  </div>

                  <hr>
                  <div class="d-flex flex-column gap-2">
                    <list-view :thead="['Total ', 'Bobot Total', 'Jumlah', 'Nilai Kinerja']">
                      <template v-slot:tbody>
                        <tr>
                          <td>Hasil Penilaian Kinerja</td>
                          <!-- <td>{{ list_penilaian_kinerja?.bobot_rinci || list_penilaian_kinerja?.bobot_rinci === 0 ? list_penilaian_kinerja.bobot_rinci : '-' }}</td> -->
                          <td>{{ list_penilaian_kinerja?.bobot_total || list_penilaian_kinerja?.bobot_total === 0 ? list_penilaian_kinerja.bobot_total : '-' }}</td>
                          <td>{{ list_penilaian_kinerja?.sub_jumlah_kinerja || list_penilaian_kinerja?.sub_jumlah_kinerja === 0 ? list_penilaian_kinerja.sub_jumlah_kinerja : '-' }}</td>
                          <td>{{ list_penilaian_kinerja?.average_kinerja || list_penilaian_kinerja?.average_kinerja === 0 ? list_penilaian_kinerja.average_kinerja : '-' }}</td>
                        </tr>
                      </template>
                    </list-view>
                  </div>
                </div>
              </FieldsetComponent>
            </div>

            <div class="tab-pane fade show p-4 pt-0" id="pills-penugasan-khusus" role="tabpanel"
              aria-labelledby="pills-penugasan-khusus-tab">
              <FieldsetComponent title="Penugasan Khusus" :isFieldsetRow="true">
                
                <div class="mt-2">
                  <div class="d-flex flex-column gap-2">
                    <list-view>
                      <template v-slot:thead>
                        <tr>
                          <th scope="col" colspan="2" class="p-2">Jenis Penugasan</th>
                        </tr>
                      </template>
                      <template
                        v-if="list_penugasan_khusus?.list_penugasan?.length > 0"
                        v-slot:tbody
                      >
                        <tr
                          v-for="item in list_penugasan_khusus?.list_penugasan"
                          :key="item"
                        >
                          <td colspan="2">
                            {{ item?.name || '-' }}
                          </td>
                        </tr>
                      </template>
                      <template v-else v-slot:tbody>
                        <tr>
                          <td colspan="2" class="text-center">-</td>
                        </tr>
                      </template>
                      <template v-slot:tfoot>
                        <tr>
                          <td>Nilai Penugasan Khusus</td>
                          <td>{{ list_penugasan_khusus?.nilai || list_penugasan_khusus?.nilai === 0 ? list_penugasan_khusus.nilai : '-'  }}</td>
                        </tr>
                      </template>
                    </list-view>
                  </div>
                </div>
              </FieldsetComponent>
            </div>

            <div class="tab-pane fade show p-4 pt-0" id="pills-pengurangan" role="tabpanel"
              aria-labelledby="pills-pengurangan-tab">
              <FieldsetComponent title="Pengurangan" :isFieldsetRow="true">

                <div class="mt-2">
                  <div class="d-flex flex-column gap-2">
                    <list-view :thead="['Tingkat Permasalahan', 'Jumlah']">
                      <template
                        v-if="list_pengurangan?.detail?.length > 0"
                        v-slot:tbody
                      >
                        <tr
                          v-for="item in list_pengurangan.detail"
                          :key="item"
                        >
                          <td>{{ item?.tingkat_permasalahan || '-' }}</td>
                          <td>{{ item?.jumlah_permasalahan || item?.jumlah_permasalahan === 0 ? item.jumlah_permasalahan : '-' }}</td>
                        </tr>
                      </template>
                      <template v-else v-slot:tbody>
                        <tr>
                          <td colspan="2" class="text-center">-</td>
                        </tr>
                      </template>
                    </list-view>
                  </div>
                </div>
              </FieldsetComponent>
            </div>

            <div class="tab-pane fade show p-4 pt-0" id="pills-kompetensi" role="tabpanel" aria-labelledby="pills-kompetensi-tab">
              <FieldsetComponent :isFieldsetRow="true">

                <template v-if="list_kompetensi_inti.length > 0">
                  <h5>Kompetensi Inti</h5>

                  <div
                    v-for="item in list_kompetensi_inti"
                    :key="item"
                    class="mt-4"
                  >
                    <div class="d-flex flex-row justify-content-between mt-3 mb-1">
                      <div>{{ item?.kompetensi || '-' }}</div>
                    </div>
                    <div class="d-flex flex-column gap-2">
                      <!-- <list-view :thead="['Jenis Kompetensi', 'Level', 'Deskripsi', 'Nilai']"> -->
                      <list-view :thead="['Level', 'Deskripsi']">
                        <template v-slot:tbody>
                          <tr>
                            <td>{{ item.nilai }} skala dari {{ item?.maksimal || '-' }}</td>
                            <td>{{ item.list_kompetensi?.['level'+ item.nilai] || '-' }}</td>
                          </tr>
                        </template>
                      </list-view>
                    </div>
                  </div>
                </template>

                <template v-if="list_kompetensi_manajerial.length > 0">
                  <hr class="mt-5 mb-4">
                  <h5>Kompetensi Manajerial</h5>

                  <div
                    v-for="item in list_kompetensi_manajerial"
                    :key="item"
                    class="mt-4"
                  >
                    <div class="d-flex flex-row justify-content-between mt-3 mb-1">
                      <div>{{ item?.kompetensi || '-' }}</div>
                    </div>
                    <div class="d-flex flex-column gap-2">
                      <!-- <list-view :thead="['Jenis Kompetensi', 'Level', 'Deskripsi', 'Nilai']"> -->
                      <list-view :thead="['Level', 'Deskripsi']">
                        <template v-slot:tbody>
                          <tr>
                            <td>{{ item.nilai }} skala dari {{ item?.maksimal || '-' }}</td>
                            <td>{{ item.list_kompetensi?.['level'+ item.nilai] || '-' }}</td>
                          </tr>
                        </template>
                      </list-view>
                    </div>
                  </div>
                </template>
              </FieldsetComponent>
            </div>

            <div class="tab-pane fade show p-4 pt-0" id="pills-penilaian-akhir" role="tabpanel"
              aria-labelledby="pills-penilaian-akhir-tab">
              <FieldsetComponent title="Penilaian Akhir" :isFieldsetRow="true">

                <div class="d-flex flex-column gap-2">
                  <div class="d-flex flex-column gap-2">
                    <list-view :thead="['Kategori', 'Nilai', 'Bobot', 'Nilai Akhir']">
                      <template v-slot:tbody>
                        <tr>
                          <td>Rata-rata Nilai Kinerja</td>
                          <td>{{ data_penilaian_akhir?.nilai_kinerja?.average_kinerja || data_penilaian_akhir?.nilai_kinerja?.average_kinerja === 0 ? data_penilaian_akhir.nilai_kinerja.average_kinerja : '-' }}</td>
                          <td>{{ data_penilaian_akhir?.nilai_kinerja?.bobot_kinerja || data_penilaian_akhir?.nilai_kinerja?.bobot_kinerja === 0 ? data_penilaian_akhir.nilai_kinerja.bobot_kinerja +'%' : '-' }}</td>
                          <td>{{ data_penilaian_akhir?.nilai_kinerja?.nilai_akhir_kinerja || data_penilaian_akhir?.nilai_kinerja?.nilai_akhir_kinerja === 0 ? data_penilaian_akhir.nilai_kinerja.nilai_akhir_kinerja : '-' }}</td>
                        </tr>
                        <tr>
                          <td>Rata-rata Perilaku Kompetensi</td>
                          <td>{{ data_penilaian_akhir?.kompetensi?.average_kompetensi || data_penilaian_akhir?.kompetensi?.average_kompetensi === 0 ? data_penilaian_akhir.kompetensi.average_kompetensi : '-' }}</td>
                          <td>{{ data_penilaian_akhir?.kompetensi?.bobot_kompetensi || data_penilaian_akhir?.kompetensi?.bobot_kompetensi === 0 ? data_penilaian_akhir.kompetensi.bobot_kompetensi +'%' : '-' }}</td>
                          <td>{{ data_penilaian_akhir?.kompetensi?.nilai_akhir_kompetensi || data_penilaian_akhir?.kompetensi?.nilai_akhir_kompetensi === 0 ? data_penilaian_akhir.kompetensi.nilai_akhir_kompetensi : '-' }}</td>
                        </tr>
                        <tr>
                          <td colspan="3">Penugasan Khusus, Rangkap Jabatan, Inovasi & Kreatifitas</td>
                          <td>{{ data_penilaian_akhir?.penugasan_khusus || data_penilaian_akhir?.penugasan_khusus === 0 ? data_penilaian_akhir.penugasan_khusus : '-' }}</td>
                        </tr>
                        <tr>
                          <td colspan="3">Faktor Pengurang KPI</td>
                          <td>{{ data_penilaian_akhir?.pengurang || data_penilaian_akhir?.pengurang === 0 ? data_penilaian_akhir.pengurang : '-' }}</td>
                        </tr>
                      </template>
                      <template>
                      </template>
                    </list-view>

                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col" style="padding-left: 0; padding-right: 0;" colspan="3">Nilai Akhir</th>
                            <th scope="col" style="text-align: right; padding-left: 0; padding-right: 0;">{{ data_penilaian_akhir?.nilai_akhir || data_penilaian_akhir?.nilai_akhir === 0 ? data_penilaian_akhir.nilai_akhir : '-' }}</th>
                          </tr>
                          <tr>
                            <th scope="col" style="padding-left: 0; padding-right: 0;" colspan="3">Indeks</th>
                            <th scope="col" style="text-align: right; padding-left: 0; padding-right: 0;">{{ data_penilaian_akhir?.indeks || '-' }}</th>
                          </tr>
                        </thead>
                      </table>
                    </div>

                    <!-- <ArgonAlert title="Catatan" color="primary">Tingkatkan lagi kompetensi</ArgonAlert> -->
                  </div>
                </div>
              </FieldsetComponent>
            </div>
          </tabbed-pane>
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import CardComponent from '@/components/CardComponent.vue';
import EmployeeApi from '@/repository/api/EmployeeApi';
import TabbedPane from '@/components/TabbedPane.vue';
import FieldsetComponent from '@/components/FieldsetComponent.vue';
import ListView from '@/components/ListView.vue';
// import ArgonAlert from '@/components/ArgonAlert.vue';
import Vue3Html2pdf from 'vue3-html2pdf';
import moment from 'moment';

import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import LaporanPersonalApi from "@/repository/api/LaporanPersonalApi";

export default {
  name: "tables",
  components: {
    MetaSection,
    GridRow,
    GridCol,
    ArgonButton,
    CardComponent,
    TabbedPane,
    FieldsetComponent,
    ListView,
    // ArgonAlert,
    Vue3Html2pdf,
  },
  data() {
    return {
      moment,
      timer: null,
      employee: {},
      periode_active: null,

      employee_login: null,

      params: {
        jabatan_id: "",
        unitkerja_id: "",
        keyword: "",
        status: "",
        page: 1,
      },
      mutasiData: {},
      unitkerja: [],
      jabatan: [],
      jabatanMutasi: [],
      checked: [],
      isCheckAll: false,
      metaData: {},

      list_penilaian_kinerja: [],
      list_penugasan_khusus: [],
      list_pengurangan: [],
      list_kompetensi_inti: [],
      list_kompetensi_manajerial: [],
      data_penilaian_akhir: null,
    };
  },
  computed: {
    employee_id() {
      return this.$route.params?.employee_id;
    },
    realization_id() {
      return this.$route.params?.realization_id;
    },
    periode_id() {
      return this.$route.params?.periode_id;
    },
    // total_nilai() {
    //   let total = 0;

    //   if (this.list_kompetensi_inti.length > 0) {
    //     this.list_kompetensi_inti.forEach(item => {
    //       total += item.nilai;
    //     });
    //   }

    //   if (this.list_kompetensi_manajerial.length > 0) {
    //     this.list_kompetensi_manajerial.forEach(item => {
    //       total += item.nilai;
    //     });
    //   }

    //   return total;
    // },
    
    // nilai_kompetensi() {
    //   let total = 0;
    //   total = (this.total_nilai / this.max_jabatan) * 5;
    //   return total;
    // },
    // max_jabatan() {
    //   let total = 0;
    //   let inti = this.employee?.jabatan?.inti || 0;
    //   let manajerial = this.employee?.jabatan?.manajerial || 0;

    //   total = (inti * 5) + (manajerial * 5);

    //   return total;
    // },
  },
  watch: {
    // total_nilai() {},
    // nilai_kompetensi() {},
    // max_jabatan() {},
  },
  methods: {
    sumBobotSubKpi(data) {
      data = data.map((item) => Number.parseFloat(item?.bobot || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },
    sumNilaiPenugasan(data) {
      data = data.map((item) => Number.parseFloat(item?.nilai || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },

    generateReport() {
      console.log(this.$refs.html2Pdf)
      this.$refs.html2Pdf.generatePdf()
    },
    async getEmployee() {
      await EmployeeApi.get(this.employee_id)
        .then((resp) => {
          this.employee = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getKpiPeriode() {
      console.log('this.periode_id', this.periode_id)
      await KpiPeriodeApi.get(this.periode_id)
        .then((response) => {
          this.periode_active = response?.data || {};
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenilaianKpi() {
      await LaporanPersonalApi.getDetailPenilaianKinerja({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_penilaian_kinerja = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenugasanKhusus() {
      await LaporanPersonalApi.getDetailPenugasanKhusus({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_penugasan_khusus = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPengurangan() {
      await LaporanPersonalApi.getDetailPengurangan({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_pengurangan = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getKompetensi() {
      await LaporanPersonalApi.getDetailKompetensi({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          const list = resp?.data;
          this.list_kompetensi = list;
          // console.log(list)

          if (list?.nilai_perkompetensi) {
            
            this.list_kompetensi_inti = list.nilai_perkompetensi.filter(item => item?.type === 'inti');
            this.list_kompetensi_manajerial = list.nilai_perkompetensi.filter(item => item?.type === 'manajerial');
          }

        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenilaianAkhir() {
      await LaporanPersonalApi.getDetailPenilaianAkhir({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.data_penilaian_akhir = resp?.data || null;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getExportPdf() {
      this.$store.state.loading = true;

      await LaporanPersonalApi.getDetailExportPdf({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
        periode_id: this.periode_id,
      })
        .then((resp) => {
          // console.log(resp);
          // window.open(URL.createObjectURL(resp?.data), '__blank');
          // =====================================================================

          const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          // fileLink.setAttribute('download', 'file.pdf');
          fileLink.setAttribute('download', 'laporan_kpi_pegawai_'+ this.employee?.name?.replaceAll(' ', '_')?.toLowerCase() +'_'+ moment() +'.pdf');
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch((err) => {
          console.log(err)
        });
      
      this.$store.state.loading = false;
    },
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getSessionUser();
    this.employee_login = this.$store.state?.sessionUser?.employee || '';
    
    await this.getEmployee();
    await this.getKpiPeriode();
    await this.getPenilaianKpi();
    await this.getPenugasanKhusus();
    await this.getPengurangan();
    await this.getKompetensi();
    await this.getPenilaianAkhir();
    this.$store.state.loading = false;
  },
};
</script>


<style scoped>
.report-table {
  width: 100%;
}

.report-table td, th {
  font-size: 11px;
  padding: 4px;
}

.report-table th {
  text-align: center;
  background-color: aliceblue;
  border-left: 1px solid #d8dce3;
  border-bottom: 1px solid #d8dce3;
  border-top: 1px solid #d8dce3;
}
.report-table th:last-child {
  border-right: 1px solid #d8dce3;
}
.report-table--main td {
  border-bottom: 1px solid #d8dce3;
  border-left: 1px solid #d8dce3;
}
.report-table--main td:last-child {
  border-right: 1px solid #d8dce3;
}

.report-table--result tr:first-child td {
  border-top: 1px solid #d8dce3;
}

.block-area-report {
  margin-top: 24px;
}

.block-area-report--heading {
  font-size: 14px;
}
</style>